export default __webpack_public_path__ + "static/media/9bb1c40ad8b43d5b67d1774b6bf59695.jpg";